//

const setPageInit = () => {
  //

  const muWrapperElem = document.querySelector('#mu_wrapper');

  setTimeout(() => {
    muWrapperElem.classList.add('displayOn');
  }, 100);

  setTimeout(() => {
    muWrapperElem.classList.add('fadeIn');
    setSwiper();
  }, 200);

  //

  setTimeout(() => {
    setFvScroll();
    setScroll();
    setFilter();
  }, 300);

  //
};
setTimeout(() => {
  setPageInit();
}, 100);

//

const setSwiper = () => {
  //

  const swiperFv = new Swiper('.swiper_fv', {
    pagination: {
      el: '.swiper-pagination_fv',
      clickable: true,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    speed: 2000,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
      waitForTransition: false,
    },
    loopAdditionalSlides: 3,
    on: {
      // init: () => {
      //   setTimeout(() => {
      //     let nowNum = swiperFv.activeIndex;
      //     setTopFvCatchMove(nowNum);
      //   }, 1);
      // },
      transitionStart: () => {
        const activeElem = document.querySelector('.swiper_fv .swiper-slide-active');
        activeElem.classList.add('swiper-slide-on');

        const onElems = document.querySelectorAll('.swiper_fv .swiper-slide-on');
        onElems.forEach((elem) => {
          if (!elem.classList.contains('swiper-slide-active')) {
            setTimeout(() => {
              elem.classList.remove('swiper-slide-on');
            }, 2000);
          }
        });

        // let now = swiperFv.realIndex;
        // setTopFvCatchMove(now);
      },
    },
  });

  //
};

//

const setFvScroll = () => {
  //

  let fvScrollItems = document.querySelectorAll('.fv_top .fv_arrow');
  // let fvScrollItems = document.querySelectorAll('.exhibition .btn_shop_now a, .fv_top .fv_arrow');
  let fvElem = document.querySelector('.fv');
  let scrollValue = 0;

  fvScrollItems.forEach((item) => {
    item.addEventListener('click', function (e) {
      e.preventDefault();

      if (fvElem) {
        scrollValue = document.querySelector('#items').offsetTop;
      }
      window.scrollTo({
        top: scrollValue,
        behavior: 'smooth',
      });
    });
  });

  //
};

//

const setScroll = () => {
  //

  let scrollY = 0;
  var startPos = 0;
  var hideScrollNum = 300;

  const header = document.querySelector('header');
  const snsSolo = document.querySelector('.sns_solo');

  window.addEventListener('scroll', () => {
    scrollY = window.scrollY;
    setSnsHide(scrollY);
    // setSnsColor(scrollY);
    // setNavColor(scrollY);
  });

  //

  const setSnsHide = (scrollY) => {
    //

    if (scrollY > startPos && scrollY > hideScrollNum) {
      if (header.classList.contains('open')) {
        //
      } else {
        snsSolo.classList.add('hide');
      }
    } else {
      snsSolo.classList.remove('hide');
    }
    startPos = scrollY;

    //
  };

  const setSnsColor = (scrollY) => {
    //

    if (scrollY > window.innerHeight / 2) {
      snsSolo.classList.add('colorBlack');
    } else {
      snsSolo.classList.remove('colorBlack');
    }

    //
  };

  const setNavColor = (scrollY) => {
    //

    if (scrollY > window.innerHeight - 30 - 40 / 2) {
      header.classList.add('navBlack');
    } else {
      header.classList.remove('navBlack');
    }

    //
  };

  //
};

//

//

const setFilter = () => {
  //

  const setCountText = () => {
    //

    let countTextItems = document.querySelectorAll('#ProductCount');
    countTextItems.forEach((item) => {
      //

      // let countText = item.textContent;
      // let newStr = countText.replace('products', '');
      // item.innerText = newStr;

      //

      let countTextJp = item.textContent;
      let newStrJp = countTextJp.replace('個の商品', '');
      item.innerText = newStrJp;

      //

      // let countText = item.textContent;
      // console.log(countText);
      // let newStr = countText.slice(-9, -5) + '';
      // // let newStr = countText.slice(-10, -5) + '';
      // item.innerText = newStr;

      //
    });

    //
  };
  setCountText();

  //

  const setFilterOpen = () => {
    //

    const filterWrap = document.querySelector('.control .filter_wrap');
    const filterBtn = filterWrap.querySelector('.btn_filter');
    const filterFixed = document.querySelector('.filter_fixed');
    const filterFixedCloseBtn = filterFixed.querySelector('.filter_fixed_close');
    const filterBgCloseBtn = filterFixed.querySelector('.bg_close');
    const filterViewResultsBtn = filterFixed.querySelector('.btn_view_results');
    filterBtn.addEventListener('click', () => {
      filterFixed.classList.add('open');
    });
    filterFixedCloseBtn.addEventListener('click', () => {
      filterFixed.classList.remove('open');
    });
    filterBgCloseBtn.addEventListener('click', () => {
      filterFixed.classList.remove('open');
    });
    filterViewResultsBtn.addEventListener('click', () => {
      filterFixed.classList.remove('open');
    });

    //
  };
  setFilterOpen();

  //

  const setFilterEvent = () => {
    //

    document.addEventListener('click', function (event) {
      // フィルターの項目や、動的に変化した要素をクリックした時に動作
      if (event.target.matches('.facet-checkbox') || event.target.closest('.facet-checkbox')) {
        // console.log('フィルターをクリック');
        // フィルタリング処理の後に実行したい内容
      }
    });

    //
  };
  // setFilterEvent();

  //

  const setFilterClear = () => {
    //

    console.log('');

    // const targetItems = document.querySelectorAll('#FacetSortDrawerForm');
    // targetItems.forEach((item) => {
    //   console.log(item);
    // });

    //

    // const filterFormItems = document.querySelectorAll('.facets__form-vertical');

    // document.querySelector('.btn_filter_clear').addEventListener('click', () => {
    //   const url = new URL(window.location.href); // URLを取得
    //   history.replaceState(null, '', url.pathname); // URLからクエリパラメータを削除

    //   //

    //   // filterFormItems.forEach((item) => {
    //   //   // console.log(item);
    //   //   item.reset();
    //   //   // item.submit();
    //   // });
    // });

    //

    // document.querySelector('.btn_filter_clear').addEventListener('click', () => {
    //   const checkboxes = document.querySelectorAll('input[name="filter.p.m.custom.artist"]');
    //   checkboxes.forEach((checkbox) => {
    //     checkbox.checked = false;
    //   });

    //   // console.log('clear');
    //   // document.querySelector('input[id=Filter-filter.p.m.custom.artist-1]').checked = false;
    // });

    //
  };
  // setFilterClear();

  //

  const setFilterText = () => {
    //

    let elems = document.querySelectorAll('.js-filter');
    elems.forEach((elem) => {
      elem.setAttribute('open', '');
    });

    //

    const jsFilterElems = document.querySelectorAll('.filter_fixed .js-filter');

    // console.log(jsFilterElems[0]);
    // const target = jsFilterElems[4];
    // target.document.querySelector('li');
    // console.log(jsFilterElems[3].querySelector('li'));

    // if (jsFilterElems[0]) {
    //   jsFilterElems[0].classList.add('titleHide');
    // }
    // if (jsFilterElems[1]) {
    //   jsFilterElems[1].classList.add('titleHide');
    // }
    // if (jsFilterElems[2]) {
    //   jsFilterElems[2].classList.add('titleHide');
    // }

    // let targets = jsFilterElems[0].querySelector('li').querySelectorAll('.facet-checkbox__text');
    // targets.forEach((target, i) => {
    //   // console.log(target);
    //   // console.log(target.innerHTML);
    //   // target.innerHTML = 'AVAILABILITY';
    //   // setTimeout(() => {}, 500);
    // });

    //

    // jsFilterElems.forEach((elem, i) => {
    //   // const targetUl = elem.querySelector('ul')[0];
    //   // const targetLi = targetUl.querySelector('li')[0];
    //   // targetLi.classList.add('targettargettarget');
    // });

    //

    // let elems = document.querySelectorAll('.js-filter');
    // elems.forEach((elem) => {
    //
    // elem.setAttribute('open', '');
    //
    // let countTextJp = item.textContent;
    // let newStrJp = countTextJp.replace('個の商品', '');
    // item.innerText = newStrJp;
    //
    // let countText = item.textContent;
    // console.log(countText);
    // let newStr = countText.slice(-9, -5) + '';
    // // let newStr = countText.slice(-10, -5) + '';
    // item.innerText = newStr;
    //
    // });

    //
  };
  setFilterText();

  //
};
setFilter();
